import type { RootState } from 'store';

export const getConnections = (state: RootState) =>
  state.unitConnGroup.present.connectionState.connections;
